import { TmTradeApply } from '@templates/tm-trade-apply'
import { getNonCmsPageStaticProps, renderNonCmsPage } from '@utils/non-cms-page'
import { NotFoundPgPage, PgPageProps } from 'pages/[[...slug]]'

export const getStaticProps = getNonCmsPageStaticProps

const TradeApplyPage = (props: PgPageProps | NotFoundPgPage) => {
  return renderNonCmsPage('Trade Application', { ...props, slug: 'trade/apply' }, <TmTradeApply />)
}

export default TradeApplyPage
